/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Badge_UnreadInputs */

const en_us2_shell_badge_unread = /** @type {(inputs: Shell_Badge_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const pt_br2_shell_badge_unread = /** @type {(inputs: Shell_Badge_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova`)
};

const es_419_shell_badge_unread = /** @type {(inputs: Shell_Badge_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const pt_pt2_shell_badge_unread = /** @type {(inputs: Shell_Badge_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova`)
};

const fr_fr2_shell_badge_unread = /** @type {(inputs: Shell_Badge_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const de_de2_shell_badge_unread = /** @type {(inputs: Shell_Badge_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const it_it2_shell_badge_unread = /** @type {(inputs: Shell_Badge_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Shell_Badge_UnreadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_badge_unread = /** @type {((inputs?: Shell_Badge_UnreadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Badge_UnreadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_badge_unread(inputs)
	if (locale === "es-419") return es_419_shell_badge_unread(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_badge_unread(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_badge_unread(inputs)
	if (locale === "de-DE") return de_de2_shell_badge_unread(inputs)
	if (locale === "it-IT") return it_it2_shell_badge_unread(inputs)
	return en_us2_shell_badge_unread(inputs)
});
export { shell_badge_unread as "shell.badge_unread" }